import './cell-list.css';

import { Fragment, useEffect } from 'react';

import { useActions } from '../hooks/use-actions';
import { useTypedSelector } from '../hooks/use-typed-selector';
//import { fetchCells } from '../state/action-creators/index';
import AddCell from './add-cell';
import CellListItem from './cell-list-item';

const CellList: React.FC = () => {
    const cells = useTypedSelector(({cells: {order, data}}) =>
        order.map((id) => data[id]),
    );

    const {fetchCells} = useActions();

    useEffect(() => {
        fetchCells();
    }, [fetchCells]);

    const renderedCells = cells.map((cell) => (
        <Fragment key={cell.id}>
            <CellListItem cell={cell} />
            <AddCell previousCellId={cell.id} />
        </Fragment>
    ));

    return (
        <div className='cell-list'>
            <AddCell forceVisible={cells.length === 0} previousCellId={null} />
            {renderedCells}
        </div>
    );
};

export default CellList;
